export function viewCommunityProfile(id, router) {
  if (id) router.push("/community/" + id);
}

export function viewProfile(id, router) {
  if (id) router.push("/profile/" + id);
}

export function viewHashtagPosts(value, postType, router) {
  let link = null;

  
  if (postType && (postType === "feeds" || postType === "clips")) {
    link = `/hashtag/${postType}/${value}`;
  } else if (router.pathname === "clips") link = `/hashtag/clips/${value}`;
  else link = `/hashtag/feeds/${value}`;

  router.push(link);
}
